import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

const Search = ({ onSearch }) => {
  const [search, setSearch] = useState("");

  const onInputChange = (value) => {
    setSearch(value);
    onSearch(value);
  };
  return (
    <div className="input-container-search">
      <input
        type="text"
        className="form-control search-input"
        style={{ width: "240px" }}
        placeholder="Search"
        value={search}
        onChange={(e) => onInputChange(e.target.value)}
      />
      <div className="search-icon-container">
        <FaSearch className="search-icon " style={{ color: "lightgray" }} />
      </div>
    </div>
  );
};

export default Search;
